import React, { useState } from "react";
import CardImg from "../../../../components/CardImg";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * 1 Day Dragon Tiger (dt6 / pdt6 / tdt6) card overlay for VideoBox — reference markup:
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *   > div > (Dragon card, Tiger card) — no dealer-name, unlike 20-20 Dragon Tiger.
 * Like the reference: hidden while the first card is a back ("1"); the shuffle handle toggles it.
 */
export default function Dt6CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  const cards = (Array.isArray(card) ? card : String(card ?? "").split(","))
    .map((c) => String(c).trim());
  if (!String(card ?? "").length || !cards.length) return null;
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div>
          <span>
            <CardImg src={`${IMG}/${cards[0]}.png`} alt="" />
          </span>{" "}
          <span>
            <CardImg src={`${IMG}/${cards[1] ?? "1"}.png`} alt="" />
          </span>
        </div>
      </div>
    </div>
  );
}
